<template>
    <div class="text-center">
        <v-dialog
            v-model="show"
            width="unset"
            max-width="400"
            tabindex="-1"
            role="dialog"
            transition="v-expand-y-transition"
            persistent
        >
            <v-card
                class="elevation-12"
                transition="v-expand-y-transition"
            >
                <v-container class="pa-7">
                    <h1 class="text-center">
                        {{ notification.subject }}
                    </h1>
                    <p class="mt-6 mb-0 grey--text">
                        {{ notification.message }}
                    </p>
                </v-container>

                <v-card-actions class="justify-space-around py-4">
                    <v-btn
                        v-for="(action, key) in notification.actions"
                        :key="key"
                        color="primary"
                        dark
                        @click="handleAction(action)"
                    >
                        {{ action.text }}
                    </v-btn>
                </v-card-actions>
            </v-card>

            <v-overlay
                :value="loading"
                absolute
            >
                <v-progress-circular
                    :size="70"
                    :width="7"
                    indeterminate
                />
            </v-overlay>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        notification: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        loading: false,
        show: true,
    }),
    methods: {
        async handleAction(action) {
            try {
                this.loading = true;
                await Vue.backendApi()
                    .notifications()
                    .action(this.notification.id, action);
            } catch (error) {
                this.$swal({
                    type: 'error',
                    title: 'Something went wrong',
                    text: error,
                });
                throw error;
            } finally {
                this.loading = false;
                this.show = false;
            }
        },
    },
};
</script>
